import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, gridSlice, loadersSlice, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'
import { RequestParams, ResponseCatalog } from 'Models'
import { orderApi, orderSelectors, ordersSlice } from 'Pages/orders_design'
import {
	UnBlockRequestModel,
	unblockRequestApi,
	getUnBlockRequestSelector,
	UnBlockRequestNS,
	unBlockRequestSlice,
} from 'Pages/orders'

function* getAllUnBlockRequest(requestParams?: RequestParams, clear = false) {
	try {
		let params
		if (requestParams) {
			params = requestParams
		} else {
			params = yield* select(getUnBlockRequestSelector.getAll)
		}
		const { page, per_page, query, ...fields } = params
		const currentParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(unBlockRequestSlice.actions.clearAll())
		}
		const res = yield* call(unblockRequestApi.getAll, currentParams)
		const entries = res.entries.map(
			(unBlock): UnBlockRequestModel => Deserialize(unBlock, UnBlockRequestModel)
		)
		const UnBlockRequests = new ResponseCatalog<UnBlockRequestModel>(res)
		UnBlockRequests.entries = entries
		if (!clear) {
			const olderRequests = yield* select(getUnBlockRequestSelector.getAll)
			UnBlockRequests.entries = [...olderRequests, ...entries]
		}
		yield* put(unBlockRequestSlice.actions.setParams(requestParams))
		yield* put(unBlockRequestSlice.actions.setAll(UnBlockRequests))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAll(action: UnBlockRequestNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		yield* call(getAllUnBlockRequest, params, clear)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* confirm(action: UnBlockRequestNS.Confirm) {
	try {
		const { id, comment } = action.payload
		const params = yield* select(getUnBlockRequestSelector.getParams)
		yield* call(unblockRequestApi.confirm, id, comment)
		const unBlockRequest = yield* call(unblockRequestApi.getOne, action.payload.id)
		yield* put(unBlockRequestSlice.actions.setOneUpdate(unBlockRequest))
		yield* call(getAllUnBlockRequest, params)
		yield* call(notifyMessageCreator, 'common.unblock.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* decline(action: UnBlockRequestNS.Decline) {
	try {
		const { id, comment } = action.payload
		const params = yield* select(getUnBlockRequestSelector.getParams)
		yield* call(unblockRequestApi.decline, id, comment)
		const unBlockRequest = yield* call(unblockRequestApi.getOne, action.payload.id)
		yield* put(unBlockRequestSlice.actions.setOneUpdate(unBlockRequest))
		yield* call(getAllUnBlockRequest, params)
		yield* call(notifyMessageCreator, 'common.unblock_request.rejected')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* clarify(action: UnBlockRequestNS.Clarify) {
	try {
		const { id, comment } = action.payload
		const params = yield* select(getUnBlockRequestSelector.getParams)
		yield* call(unblockRequestApi.clarify, id, comment)
		const unBlockRequest = yield* call(unblockRequestApi.getOne, action.payload.id)
		yield* put(unBlockRequestSlice.actions.setOneUpdate(unBlockRequest))
		yield* call(getAllUnBlockRequest, params)
		yield* call(notifyMessageCreator, 'common.unblock_request.clarify')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* backToChecking(action: UnBlockRequestNS.BackToChecking) {
	try {
		const { id, data } = action.payload
		yield* call(notifyMessageCreator, 'common.files_send.start')
		yield* put(unBlockRequestSlice.actions.loadBackToChecking)
		yield* call(unblockRequestApi.backToChacking, id, data)
		yield* call(notifyMessageCreator, 'common.sending.success')
		yield* put(unBlockRequestSlice.actions.successBackToChecking)
		const requestParams = yield* select(orderSelectors.getParams)
		const res = yield* call(orderApi.getAll, requestParams)
		yield* put(ordersSlice.actions.setAll(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getOne(action: UnBlockRequestNS.GetOne) {
	try {
		const unBlockRequest = yield* call(unblockRequestApi.getOne, action.payload)
		yield* put(unBlockRequestSlice.actions.setOne(unBlockRequest))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* setStatusAgreement(action: UnBlockRequestNS.SetStatusAgreement) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(unblockRequestApi.setStatusAgreement, action.payload.id, action.payload.status)
		yield* put(unBlockRequestSlice.actions.getOne(action.payload.idRequest))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export const unblockRequestSaga = function* saga() {
	yield* takeEvery(unBlockRequestSlice.actions.getAll.type, getAll)
	yield* takeEvery(unBlockRequestSlice.actions.confirm.type, confirm)
	yield* takeEvery(unBlockRequestSlice.actions.decline.type, decline)
	yield* takeEvery(unBlockRequestSlice.actions.clarify.type, clarify)
	yield* takeEvery(unBlockRequestSlice.actions.backToChecking.type, backToChecking)
	yield* takeEvery(unBlockRequestSlice.actions.getOne.type, getOne)
	yield* takeEvery(unBlockRequestSlice.actions.setStatusAgreement.type, setStatusAgreement)
}
